import axios, { AxiosError, ResponseType } from 'axios';
import { get } from 'lodash';
import { stringify } from 'qs';

import {
  ApiError,
  FcopyOverviewQueryParams,
  ICreateFolderRequest,
  ICreateFolderResponse,
  IFcopyOverviewResponse,
  ILoginRequest,
  IUploadRequest,
  IUploadResponse,
} from '../@types/api';
import serverConfig from '../config/serverConfig';

export const to = async <T = unknown, E = unknown>(
  promise: Promise<T>,
): Promise<[E, undefined] | [undefined, T]> => {
  try {
    const result = await promise;
    return [undefined, result];
  } catch (e) {
    return [e as E, undefined];
  }
};

const apiTo = <T>(promise: Promise<T>) =>
  to<T, AxiosError<{ error: ApiError }>>(promise);

const URL_PREFIX = serverConfig.apiHost;
// const URL_PREFIX = `http://localhost:3000/fcopy/api/1.0`;

const genericCaller = async <T>({
  url,
  params,
  method,
  headers,
  reqBody,
  responseType,
  urlPrefix = URL_PREFIX,
}: {
  url: string;
  params?: unknown;
  method: 'GET' | 'POST' | 'PUT';
  headers?: object;
  reqBody?: unknown;
  responseType?: ResponseType;
  urlPrefix?: string;
}) => {
  const [error, response] = await apiTo(
    axios.request<T>({
      url: `${urlPrefix}${url}`,
      params,
      method,
      data: reqBody,
      headers: { ...headers },
      withCredentials: false,
      responseType,
    }),
  );

  if (error) {
    // if (
    //   error.response?.status === 401 ||
    //   error.response?.status === 403 ||
    //   error.code === 'ERR_NETWORK'
    // ) {
    //   window.location.href = '/aocengit-fcopy-frontend';
    //   return Promise.reject(error);
    // } else {
    return {
      errorMessage: get(error, 'response.data.error.details', 'Error'),
      // };
    };
  }

  return { response: response?.data };
};

export const getOverviewInfo = async (
  params: FcopyOverviewQueryParams,
  token: string | undefined,
) => {
  const newParams: FcopyOverviewQueryParams = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value) newParams[key] = value;
  });
  return genericCaller<IFcopyOverviewResponse>({
    url: `${URL_PREFIX}/overview?${stringify(newParams)}`,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    urlPrefix: '',
  });
};

export const createFolder = async (
  body: ICreateFolderRequest,
  token: string | undefined,
) =>
  genericCaller<ICreateFolderResponse>({
    url: `${URL_PREFIX}/create`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    urlPrefix: '',
    reqBody: body,
  });

export const updloadTargetFiles = async (
  body: IUploadRequest,
  token: string | undefined,
) =>
  genericCaller<IUploadResponse>({
    url: `${URL_PREFIX}/upload`,
    method: 'POST',
    headers: {
      'content-type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
    urlPrefix: '',
    reqBody: body,
  });

export const login = async (body: ILoginRequest, token: string | undefined) =>
  genericCaller({
    url: `${URL_PREFIX}/login`,
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    urlPrefix: '',
    reqBody: body,
  });

export const logout = async (token: string | undefined) =>
  genericCaller<IUploadResponse>({
    url: `${URL_PREFIX}/logout`,
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    urlPrefix: '',
    reqBody: {},
  });
